import createPartnerApi from '@rhg/libs/api/create-partner-api';
import { queryKeys, useQuery } from '@rhg/libs/react-query';

export const publicBrandingPartnerConfigQueryOptions = {
    queryKey: function (accessCode: string) {
        return [queryKeys.publicBrandingPartnerConfig, accessCode];
    },
    queryFn: async function (uniqCode: string) {
        const partnerApi = createPartnerApi(async () => '');

        const response = await partnerApi.getBrandingPartnerConfig({
            uniqCode,
        });

        return response.data;
    },
    queryOptions: function (uniqCode: string) {
        return {
            enabled: !!uniqCode,
            staleTime: 1000 * 60 * 15, // 15 minutes
        };
    },
};

export function usePublicBrandingPartnerConfig(accessCode = '') {
    const { queryKey, queryFn, queryOptions } =
        publicBrandingPartnerConfigQueryOptions;
    const { enabled } = queryOptions(accessCode);

    const { data, ...otherProps } = useQuery({
        queryKey: queryKey(accessCode),
        queryFn: async () => queryFn(accessCode),
        enabled,
    });
    return {
        brandingPartnerConfig: data,
        ...otherProps,
        enabled,
    };
}
